'use client'

import { AccordionChevron, Skeleton } from '@dafiti/closet-ui'
import { Profile } from '@dafiti/closet-ui/icons'
import { cn } from '@dafiti/closet-ui/utils'

import { buildGreetingText } from '@/helpers/greeting'
import { useAuth } from '@/hooks/useAuth'
import { useMessages } from '@/i18n/useMessages'

export const MobileNavigationUserMenuGreetings = () => {
  const { auth, isLoading } = useAuth()
  const t = useMessages()

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangle"
        width="w-full"
        height="40px"
        data-testid="skeleton"
      />
    )
  }

  return (
    <div className="container flex h-[40px] items-center border-b-[1px] border-b-gray-200 active:bg-gray-200">
      <Profile className="mx-1 size-4" />

      <span
        className={cn(
          'ml-2 mr-4 truncate text-xs font-bold text-black underline',
          {
            'font-medium': !auth?.isLoggedIn,
          },
        )}
      >
        {buildGreetingText(auth, t)}
      </span>

      {auth?.isLoggedIn && (
        <div className="rotate-[90deg]">
          <AccordionChevron data-testid="accordion-chevron" />
        </div>
      )}
    </div>
  )
}
